import { graphic } from 'echarts/lib/echarts'

export function customDotBarRenderer(params, api) {
  const categoryIndex = api.value(0)
  const start = api.coord([categoryIndex, api.value(1)])
  const end = api.coord([categoryIndex, api.value(2)])
  const height = api.size([0, 1])[1] * 0.92
  const width = Math.min(api.size([0, 1])[0] * 0.9, 10)

  // console.log({start , end, width, height, size: api.size([0,1])})
  // console.log(categoryIndex, api.value(1), api.value(2), start, end, height)
  const rectShape = graphic.clipRectByRect(
    {
      x: start[0] - width * 0.5,
      y: end[1] + height * 0.04,
      width: width,
      height: height,
    },
    {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height,
    }
  )
  return (
    rectShape && {
      type: 'rect',
      shape: { ...rectShape, r: width * 0.5 },
      style: {
        ...api.style(),
      },
    }
  )
}

export function customNoteRenderer(params, api) {
  const categoryIndex = api.value(0)
  const start = api.coord([categoryIndex, api.value(1)])
  const end = api.coord([categoryIndex, api.value(1) + 1])
  const originalWidth = api.size([0, 1])[0]
  const originalHeight = api.size([0, 1])[1]
  const ySpace = start[1] - end[1]
  // console.log(ySpace, params.coordSys.y, params.coordSys.height)

  const oneSideSize = Math.min(originalWidth * 0.8, originalHeight * 0.8)
  const rectShape = graphic.clipRectByRect(
    {
      x: start[0] - oneSideSize * 0.5,
      y: end[1] + (ySpace - oneSideSize) * 0.5,
      width: oneSideSize,
      height: oneSideSize,
    },
    {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height,
    }
  )
  return (
    rectShape && {
      type: 'rect',
      shape: { ...rectShape, r: 2 },
      style: {
        ...api.style(),
      },
    }
  )
}
